<template>
  <div class="flex justify-between overflow-x-scroll md:overflow-hidden md:grid md:gap-4 md:grid-cols-3">
    <ContentPageTile
      v-for="(tile, index) in tiles"
      :key="index"
      :content="tile"
      :data-test="`content-tile-${tile.fields.slug}`"
    />
  </div>
</template>

<script setup lang="ts">
const { fetchEntries } = useContentful();

type Props = {
  content?: {
    fields?: any;
    sys?: any;
  };
};

const props = withDefaults(defineProps<Props>(), {
  content: undefined,
});

if (!props.content?.fields?.contentBanners?.length) {
  throw new Error('No content banners found');
}

const ids = props.content.fields?.contentBanners
  ?.map((banner: { sys: { id: string } | undefined }) => banner.sys?.id)
  .toString();
const { data: tiles } = await useAsyncData(async () => {
  const entries = await fetchEntries({
    contentType: 'contentPage',
    'sys.id[in]': ids,
    select: 'fields.ingress,fields.preTitle,fields.title,fields.thumbnail,fields.slug',
  });
  return entries.data || [];
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'ContentBanners',
});
</script>
